import { post } from '../../Utils/Http'
import { UserInfo } from './Model'

export async function getUserInfo() {
  var res = await post<UserInfo>('/api/user/v1/user/info')
  return res.data
}
